import { parse } from 'tldts';
import * as yup from 'yup';

yup.addMethod(yup.string, 'isIcannEmail', function (message) {
  return this.test('valid-tld', message, (value) => {
    if (!value) {
      return true;
    }
    const domain = value.split('@')[1];
    if (!domain) {
      return false;
    }
    const parsed = parse(domain);
    return parsed?.isIcann === true;
  });
});

export default yup;
